/* eslint-disable */
import React, { memo, useEffect, useMemo } from "react";
import styles from "./VideoIndex.module.css";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { filterVideoList } from "../../../common/video/VideoActions";
import FeaturedVideoCard from "./featuredVideoCard/FeaturedVideoCard";
import VideoList from "./videoList/VideoList";
import { motion, AnimatePresence } from "framer-motion";
import {
  Avatar,
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { resetfilter } from "../../../common/video/VideoFilterActions";
import ProjectIcon from "@material-ui/icons/Work";
import FilterWiget from "../../../common/components/filterWiget/FilterWiget";
import { changeMenu } from "../../../root/components/layout/header/HeaderActions";
import { filterUserList } from "../../../viewer/presenters/PresentersActions";
import { GetAllProjectList } from "../../../store/actions/ExProjectActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiMessage from "../../../components/widgets/PuiMessage";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import useResponsive from "../../../common/useResponsive";
import { isAdmin } from "../../../utils/LogicUtils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pTag: {
      marginRight: "12px",
      marginBottom: "8px",
      cursor: "pointer",
      borderRadius: "0.7em",
      height: "48px",
    },
    pTagMobile: {
      marginRight: "12px",
      marginTop: "-6px",
      borderRadius: "0.7em",
      height: "38px",
      padding: "5px 5px 5px 15px"
    },
    tag: {
      marginRight: "10px",
      marginBottom: "8px",
      cursor: "pointer",
      borderRadius: "2em",
      backgroundColor: "var(--red)",
      "&:hover": {
        backgroundColor: "rgb(193, 0, 25)",
      },
    },
    delIcon: {
      marginLeft: theme.spacing(1),
      fontSize: "24px",
    },
    projectIcon: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(-1),
      width: "30px",
      height: "30px",
      color: "var(--red)",
    },
    filterProfile: {
      width: "35px",
      height: "35px",
      margin: "0 8px 0 -8px",
      backgroundColor: "white",
    },
    filterProfileMobile: {
      width: "25px",
      height: "25px",
      margin: "0 8px 0 -8px",
      backgroundColor: "white",
    },
    msg: {
      marginTop: "65px",
    },
  })
);

interface checkObject {
  [key: string]: boolean;
}

function VideoIndex() {
  const classes = useStyles();
  const [checkedItems, setCheckedItems] = React.useState<checkObject>({});
  const [isFiltered, setIsFiltered] = React.useState(false);
  const [msg, setMsg] = React.useState<string>("");

  const { list, videos, isLoading, isEditVideo, visibleLoading } = useSelector(
    ({ video }: AppState) => video
  );
  const dispatch = useDispatch();

  const { users, userInfo, videoFilter, header, isRerunSTT } = useSelector(
    (state: AppState) => ({
      users: state.presenters.index.filteredUsers,
      userInfo: state.user.userInfo,
      videoFilter: state.videoFilter.videoFilters,
      header: state.header,
      isRerunSTT: state.exVideo.caption.isRerunSTT,
    })
  );

  const { isMobile } = useResponsive();
  const direction =
    header.direction === "left" ? -1 : header.direction === "same" ? 0 : 1;

  useEffect(() => {
    if (userInfo) {
      if (isRerunSTT) {
        setTimeout(
          () => dispatch(filterVideoList(userInfo.id, videoFilter)),
          600
        );
      } else {
        dispatch(filterVideoList(userInfo.id, videoFilter));
      }
      dispatch(GetAllProjectList(userInfo.id));
    }

    dispatch(
      filterUserList({
        id: parseInt(videoFilter.id[0]),
        skill: [],
        tag: [],
      })
    );

    for (const item of videoFilter.tag) {
      if (!checkedItems[item]) {
        setCheckedItems({
          ...checkedItems,
          [item]: true,
        });
      }
    }

    if (
      videoFilter.professional.length > 0 ||
      videoFilter.project.length > 0 ||
      videoFilter.slideFlg ||
      videoFilter.tag.length > 0
    ) {
      setIsFiltered(true);
    } else {
      setIsFiltered(false);
    }
  }, [dispatch, checkedItems, videoFilter, userInfo, isRerunSTT]);

  // ビデオ編集後、ビデオ画面に遷移するため、タグのフィルターを初期化する
  useEffect(() => {
    if (isEditVideo === true || videoFilter.tag.length === 0) {
      setCheckedItems({});
    }
  }, [isEditVideo, videoFilter]);


  const featuredVideoId = useMemo(
    () => (list.length > 0 ? list[0] : undefined),
    [list]
  );
  const otherVideoIds = useMemo(
    () => (list.length > 1 ? list.slice(1) : undefined),
    [list]
  );

  const delfilter = (type: string, item: string) => {
    switch (type) {
      case "professional":
        {
          const professionalFilter = {
            ...videoFilter,
            professional: videoFilter.professional.filter((i) => i !== item),
          };
          dispatch(resetfilter(professionalFilter));
        }
        break;
      case "project":
        {
          const projectFilter = {
            ...videoFilter,
            project: videoFilter.project.filter((i) => i !== item),
          };
          dispatch(resetfilter(projectFilter));
        }
        break;
      case "slide":
        {
          const slideFilter = {
            ...videoFilter,
            slideFlg: false,
          };
          dispatch(resetfilter(slideFilter));
        }
        break;
      case "tag":
        setCheckedItems({
          ...checkedItems,
          [item]: false,
        });
        {
          const tagFilter = {
            ...videoFilter,
            tag: videoFilter.tag.filter((i) => i !== item),
          };
          dispatch(resetfilter(tagFilter));
        }
        break;
      default:
        console.log("undefined type:" + type);
    }

    dispatch(changeMenu(header.from, header.to, "same"));
  };

  const changeProfessionalFilter = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const modFilter = {
      ...videoFilter,
      professional: event.target.value === "" ? [] : [event.target.value],
    };

    dispatch(resetfilter(modFilter));
    dispatch(changeMenu(header.from, header.to, "same"));
  };

  const changeProjectFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const modFilter = {
      ...videoFilter,
      project: event.target.value === "" ? [] : [event.target.value],
    };

    dispatch(resetfilter(modFilter));
    dispatch(changeMenu(header.from, header.to, "same"));
  };

  const changeSlideFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const modFilter = {
      ...videoFilter,
      slideFlg: event.target.checked ? true : false,
    };
    dispatch(resetfilter(modFilter));
    dispatch(changeMenu(header.from, header.to, "same"));
  };

  const changeTagFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });

    if (!videoFilter.tag.includes(event.target.name) && event.target.checked) {
      videoFilter.tag.push(event.target.name);
    }

    if (videoFilter.tag.includes(event.target.name) && !event.target.checked) {
      videoFilter.tag = videoFilter.tag.filter((t) => t !== event.target.name);
    }
    dispatch(resetfilter(videoFilter));
    dispatch(changeMenu(header.from, header.to, "same"));
  };

  const closeMsg = () => {
    setMsg("");
  };

  if (isLoading || visibleLoading) {
    return (
      <div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>
    );
  }

  const contents = (
    <>
      <div>
        <div className={isFiltered ? styles.videoArea : ""}>
          <div>
            {featuredVideoId && (
              <FeaturedVideoCard
                video={videos[featuredVideoId]}
                setMsg={setMsg}
              />
            )}
          </div>
          <div className={styles.list}>
            {otherVideoIds && (
              <VideoList
                videos={otherVideoIds.map((id) => videos[id])}
                setMsg={setMsg}
              />
            )}
          </div>
          <div>
            {list.length === 0 && !isLoading && (
              <h3>ただいま視聴できるVideoが御座いません。</h3>
            )}
          </div>
        </div>
      </div>

      <FilterWiget
        videos={list.map((id) => videos[id])}
        videoFilter={videoFilter}
        checkedItems={checkedItems}
        changeProfessionalFilter={changeProfessionalFilter}
        changeProjectFilter={changeProjectFilter}
        changeSlideFilter={changeSlideFilter}
        changeTagFilter={changeTagFilter}
      />

      <PuiMessage
        open={msg !== ""}
        type="success"
        title="登録に成功しました"
        detail={[<PuiTypography key={msg}>{msg}</PuiTypography>]}
        duration={6000}
        onClose={closeMsg}
      />
    </>
  );

  return (
    <AnimatePresence mode="wait">
      {direction !== 0 && (
        <>
          <div className={isFiltered ? styles.filter : ""}>
            <div className={styles.filterLeftArea}>
              {videoFilter.tag.map((tag, index) => (
                <Button
                  key={`${index}`}
                  size="small"
                  color="secondary"
                  variant="contained"
                  className={classes.tag}
                >
                  <PuiTypography size={14} bold={true} color="white">
                    {tag}
                  </PuiTypography>
                  {isAdmin(userInfo?.roles)&&(<HighlightOffIcon
                    className={classes.delIcon}
                    onClick={() => delfilter("tag", tag)}
                  />)}

                </Button>
              ))}
            </div>
            <div>
              {videoFilter.slideFlg && (
                <Button
                  key={"slideFlg"}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <LibraryBooksIcon className={classes.projectIcon} />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>Slide</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("slide", "slide")}
                  />
                </Button>
              )}
              {videoFilter.professional.map((professional, index) => (
                <Button
                  key={`${index}`}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <Avatar
                    className={isMobile ? classes.filterProfileMobile : classes.filterProfile}
                    src={
                      users
                        ? users.filter((user) => user.name === professional)[0]
                            ?.imageUrl
                        : ""
                    }

                  />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>{professional}</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("professional", professional)}
                  />
                </Button>
              ))}
              {videoFilter.project.map((project, index) => (
                <Button
                  key={`${index}`}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <ProjectIcon className={classes.projectIcon} />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>{project}</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("project", project)}
                  />
                </Button>
              ))}
            </div>
          </div>
          <motion.div
            key="videoIndex"
            initial={{ x: 300 * direction, opacity: 0.5 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -300 * direction, opacity: 0 }}
            className={styles.root}
          >
            {contents}
          </motion.div>
        </>
      )}

      {direction === 0 && (
        <>
          <div className={isFiltered ? styles.filter : ""}>
            <div className={styles.filterLeftArea}>ascasc
              {videoFilter.tag.map((tag, index) => (
                <Button
                  key={`${index}`}
                  size="small"
                  color="secondary"
                  variant="contained"
                  className={classes.tag}
                >
                  <PuiTypography size={14} bold={true} color="white">
                    {tag}
                  </PuiTypography>
                  <HighlightOffIcon
                    className={classes.delIcon}
                    onClick={() => delfilter("tag", tag)}
                  />
                </Button>
              ))}
            </div>
            <div>
              {videoFilter.slideFlg && (
                <Button
                  key={"slideFlg"}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <LibraryBooksIcon className={classes.projectIcon} />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>Slide</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("slide", "slide")}
                  />
                </Button>
              )}
              {videoFilter.professional.map((professional, index) => (
                <Button
                  key={`${index}`}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <Avatar
                    className={isMobile ? classes.filterProfileMobile : classes.filterProfile}

                    src={
                      users
                        ? users.filter((user) => user.name === professional)[0]
                            ?.imageUrl
                        : ""
                    }
                  />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>{professional}</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("professional", professional)}
                  />
                </Button>
              ))}
              {videoFilter.project.map((project, index) => (
                <Button
                  key={`${index}`}
                  size="medium"
                  variant="outlined"
                  className={isMobile ? classes.pTagMobile : classes.pTag}
                >
                  <ProjectIcon className={classes.projectIcon} />
                  <PuiTypography rows={1} size={isMobile ? 14 : 16}>{project}</PuiTypography>
                  <HighlightOffIcon
                    color="action"
                    className={classes.delIcon}
                    onClick={() => delfilter("project", project)}
                  />
                </Button>
              ))}
            </div>
          </div>
          <motion.div
            key="videoIndex"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
            className={styles.root}
          >
            {contents}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

export default memo(VideoIndex);
